// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f3f4f6;
}

.login-card {
  background-color: #fffdfc;
  padding: 3rem;
  border-radius: 0.8rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 40rem;
}

/* FRONT-18: Centrer les boutons verticalement */
.login-card form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-card form .form-group {
  width: 100%;
}

/* FRONT-18: Taille identique pour les deux boutons */
.login-card form > button,
.login-footer .register-button {
  min-width: 16rem;
}

.login-card h1 {
  color: #2c3948;
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 2rem;
  text-align: center;
}

.login-container .form-group {
  margin-bottom: 2rem;
}

.login-container .form-group label {
  display: block;
  color: #2c3948;
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
}

.login-container .form-group input {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  color: #2c3948;
}

.login-container .form-group input:focus {
  outline: none;
  border-color: #f97316;
}

.toggle-password-btn {
  position: absolute;
  right: 1.2rem;
  background: none;
  border: none;
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-password-btn svg {
  width: 2rem;
  height: 2rem;
  color: #2c3948;
}

.toggle-password-btn:hover svg {
  color: #f97316;
}

.login-footer {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* FRONT-18: Conteneur pour les liens mot de passe oublié et vérifier email */
.password-links-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.password-links-row .forgot-password-link,
.password-links-row .verify-email-link {
  margin: 0;
}

.register-link {
  margin-bottom: 1.2rem;
  font-size: 1.4rem;
  color: #2c3948;
}

.register-link a {
  color: #f97316;
  text-decoration: none;
  font-weight: 500;
}

.register-link a:hover {
  text-decoration: underline;
}

.forgot-password-link {
  font-size: 1.4rem;
  margin-top: 1rem;
}

.forgot-password-link a {
  color: #f97316;
  text-decoration: none;
  font-weight: 500;
}

.forgot-password-link a:hover {
  text-decoration: underline;
}

.verify-email-link {
  font-size: 1.4rem;
  margin-top: 1.2rem;
}

.verify-email-link a {
  color: #f97316;
  text-decoration: none;
  font-weight: 500;
}

.verify-email-link a:hover {
  text-decoration: underline;
}

.info-message {
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.info-message p {
  margin: 0;
  color: #1565c0;
  font-size: 1.6rem;
  line-height: 1.5;
}

/* FRONT-18: Bouton S'inscrire - même style que Se connecter mais couleurs différentes */
.register-button {
  background-color: #ffffff !important;
  color: #2c3948 !important;
  margin-top: 1.5rem !important;
  border: 1px solid #e5e7eb !important;
}

.register-button:hover {
  background-color: #f3f4f6 !important;
  color: #2c3948 !important;
  border: 1px solid #2c3948 !important;
}

.info-message p.welcome-message {
  font-size: 1.25rem;
}

.info-message p.welcome-message-link {
  font-size: 1.5rem;
  margin-top: 0.5rem;
}

.login-back-home-link {
  position: absolute;
  top: 1.75rem;
  left: 2rem;
  color: #6b7280;
  font-size: 1.2rem;
  text-decoration: none;
  transition: color 0.15s;
}

.login-back-home-link:hover {
  color: #f97316;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,qDAAqD;AACrD;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wFAAwF;AACxF;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".login-container {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  background-color: #f3f4f6;\r\n}\r\n\r\n.login-card {\r\n  background-color: #fffdfc;\r\n  padding: 3rem;\r\n  border-radius: 0.8rem;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  max-width: 40rem;\r\n}\r\n\r\n/* FRONT-18: Centrer les boutons verticalement */\r\n.login-card form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.login-card form .form-group {\r\n  width: 100%;\r\n}\r\n\r\n/* FRONT-18: Taille identique pour les deux boutons */\r\n.login-card form > button,\r\n.login-footer .register-button {\r\n  min-width: 16rem;\r\n}\r\n\r\n.login-card h1 {\r\n  color: #2c3948;\r\n  font-size: 2.4rem;\r\n  font-weight: 600;\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.login-container .form-group {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.login-container .form-group label {\r\n  display: block;\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n  margin-bottom: 0.8rem;\r\n}\r\n\r\n.login-container .form-group input {\r\n  width: 100%;\r\n  padding: 1.2rem;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 0.8rem;\r\n  font-size: 1.6rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.login-container .form-group input:focus {\r\n  outline: none;\r\n  border-color: #f97316;\r\n}\r\n\r\n.toggle-password-btn {\r\n  position: absolute;\r\n  right: 1.2rem;\r\n  background: none;\r\n  border: none;\r\n  padding: 0.6rem;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.toggle-password-btn svg {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.toggle-password-btn:hover svg {\r\n  color: #f97316;\r\n}\r\n\r\n.login-footer {\r\n  margin-top: 1.5rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n/* FRONT-18: Conteneur pour les liens mot de passe oublié et vérifier email */\r\n.password-links-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.password-links-row .forgot-password-link,\r\n.password-links-row .verify-email-link {\r\n  margin: 0;\r\n}\r\n\r\n.register-link {\r\n  margin-bottom: 1.2rem;\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.register-link a {\r\n  color: #f97316;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.register-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.forgot-password-link {\r\n  font-size: 1.4rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.forgot-password-link a {\r\n  color: #f97316;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.forgot-password-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.verify-email-link {\r\n  font-size: 1.4rem;\r\n  margin-top: 1.2rem;\r\n}\r\n\r\n.verify-email-link a {\r\n  color: #f97316;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.verify-email-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.info-message {\r\n  background-color: #e3f2fd;\r\n  border-left: 4px solid #2196f3;\r\n  padding: 12px 16px;\r\n  margin-bottom: 20px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.info-message p {\r\n  margin: 0;\r\n  color: #1565c0;\r\n  font-size: 1.6rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* FRONT-18: Bouton S'inscrire - même style que Se connecter mais couleurs différentes */\r\n.register-button {\r\n  background-color: #ffffff !important;\r\n  color: #2c3948 !important;\r\n  margin-top: 1.5rem !important;\r\n  border: 1px solid #e5e7eb !important;\r\n}\r\n\r\n.register-button:hover {\r\n  background-color: #f3f4f6 !important;\r\n  color: #2c3948 !important;\r\n  border: 1px solid #2c3948 !important;\r\n}\r\n\r\n.info-message p.welcome-message {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.info-message p.welcome-message-link {\r\n  font-size: 1.5rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.login-back-home-link {\r\n  position: absolute;\r\n  top: 1.75rem;\r\n  left: 2rem;\r\n  color: #6b7280;\r\n  font-size: 1.2rem;\r\n  text-decoration: none;\r\n  transition: color 0.15s;\r\n}\r\n\r\n.login-back-home-link:hover {\r\n  color: #f97316;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
